export enum RentalActionKeys {
  REQUEST_SERVICE = 'Request Service',
  SCHEDULE_PICKUP = 'Schedule Pick Up',
  RESCHEDULE_PICKUP = 'Reschedule Pick Up',
  PURCHASE_ORDER = 'Purchase Order',
  CANCEL_OFFRENT = 'Cancel Pickup',
}

export const RENTAL_STATUS_ID = 6;

export const RENTAL_NOTES_TYPE_ID = 2;

export const INTERNAL_RENTAL_TYPE_ID = 4;